import SiteHeader from './components/site-header';
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Tabs from "./components/tabs";
import SlidesOffers from "./components/slides-offers";
import NewsSlider from "./components/news-slider";
import DeviceManager from './utils/device-manager';
import PropertiesSlider from './components/property-slider';
import SinglePropertySlider from './components/single-property-slider';
import SeeMore from './components/see-more';
import SearchList from './components/search-drop-list';
import SearchBox from './components/search-box';
import VideoSection from './components/video-section';
import ScrollInView from './components/scroll-in-view';
import { AccordionDef } from './components/accordion';

(function($) {
    window.$ = $;
    const lang = typeof pro.lang !== 'undefined' ? pro.lang : 'en';

    $(function() {
        const $html = $('html');

        // Touch device detection
        if(DeviceManager.isHandheld()) {
            $html.addClass('touch');

            if(DeviceManager.isIos()) {
                $html.addClass('ios');
            }
        }
        else {
            $html.addClass('no-touch');
        }

        // IE detection
        if(DeviceManager.isIe11()) {
            $html.addClass('ie11');
        }
        else if(DeviceManager.isEdge()) {
            $html.addClass('edge');
        }

        // General components
        const siteHeader = new SiteHeader($('.site-header'), 20);
        //const dropdownMenu = new DropdownMenu($('.header__nav'));

        // Slides offers component
        /*const $slidesOffers = $('.slider-offers');
        if($slidesOffers.length) {
            $slidesOffers.each(function(index, el) {
                 let slidesOffers = new SlidesOffers($(el));
             });
        }*/

        // Carrousel d'offres en location
        const $propertiesSliders = $('.featured-properties-section .offers-list');
        if ($propertiesSliders.length) {
            $propertiesSliders.each(function (index, el) {
                const propertiesSlider = new PropertiesSlider($(el));
            });
        }

        // Carrousel d'offres en location - HOME
        const $propertiesSliders = $('.home-offers .offers-list');
        if ($propertiesSliders.length) {
            $propertiesSliders.each(function (index, el) {
                const propertiesSlider = new PropertiesSlider($(el));
            });
        }

        // Page détail bien - slider
        const $singlepropertySliders = $('.single-property .property-presentation__slider');
        if ($singlepropertySliders.length) {
            $singlepropertySliders.each(function (index, el) {
                const singlepropertySlider = new SinglePropertySlider($(el));
            });
        }

        // Gallery
        const tobii = new Tobii({
            captionsSelector: 'self',
            captionAttribute: 'title'
        })

        // Catalog load more component
        const $catalogLoadMoreBtns = $('.results-list__load-more-link');
        if($catalogLoadMoreBtns.length) {
            $catalogLoadMoreBtns.each(function(index, el) {
                let catalogLoadMore = new CatalogLoadMore($(el));
            });
        }

        // Catalog search form component
        const $catalogSearchForms = $('.catalog-search');
        if($catalogSearchForms.length) {
            $catalogSearchForms.each(function(index, el) {
                let catalogSearchForm = new CatalogSearchForm($(el));
            });
        }

        // Cookie consent
        if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
            // Tarteaucitron cookie settings
            let tarteaucitronLang = lang || 'en';

            if(lang === 'cn') {
                tarteaucitronLang = 'en';
            }

            const cookiesConsent = new CookiesConsent(tarteaucitronLang);
        }

        // Les liens dans les fiches d'un bien s'ouvrent dans une nouvelle fenêtre
        $('.property-presentation__content-text a').each(function() {
            $(this).attr('target', '_blank');
        });

        // Scroll in view component
        const $scrollInViewElements = $('.scroll-in-view');
        if ($scrollInViewElements.length) {
            $scrollInViewElements.imagesLoaded(function () {
                const scrollInView = new ScrollInView($scrollInViewElements);
            });
        }
    });


})(jQuery);

const accordions = document.querySelectorAll('.accordion');

if (accordions.length) {
  accordions.forEach(accordion => {
    new AccordionDef(accordion)
  })
}
